const pushServerPublicKey = 'BGdqw8b_428uMEBjp8TZFHV11z7DiSQlyBlhq8DPXqlALSOzcc4F_67z-kHP5-LphzlQPZgY_KcrMP7pAIFQOUI';

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isSupported() {
	return 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
	return Notification.requestPermission();
}

/**
 *
 */
function registerServiceWorker() {
	return navigator.serviceWorker.register('/push-sw.js');
}

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createSubscription() {
	//	wait for service worker installation to be ready
	const serviceWorker = await navigator.serviceWorker?.ready;
	// 	subscribe and return the subscription
	return serviceWorker.pushManager.subscribe({
		userVisibleOnly: true,
		applicationServerKey: pushServerPublicKey
	});
}

/**
 * returns the subscription if present or null
 */
function getSubscription() {
	//	wait for service worker installation to be ready, and then
	return navigator.serviceWorker?.ready
		.then(serviceWorker => {
			return serviceWorker.pushManager.getSubscription();
		})
		.then(pushSubscription => {
			return pushSubscription;
		});
}

export default {
	isSupported,
	askUserPermission,
	registerServiceWorker,
	createSubscription,
	getSubscription
};
